import { rootApi } from '../rootApi';

export const brandApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getAllBrands: builder.query({
            query: (params) => {
                console.log('params:', params);
                const queryParams = {
                    PageNumber: params.pageNumber + 1 ?? 1,
                    PageSize: params.pageSize ?? 10,
                    BrandName: params.brandName ?? '',
                    BrandShortName: params.brandShortName ?? '',
                    BrandItemValue: params.brandItemValue ?? '',
                    SearchText: params.searchText ?? ''
                };

                return {
                    url: 'v1/systemdefinitions/getbrand',
                    method: 'POST',
                    body: queryParams
                };
            },
            providesTags: ['Brand']
        }),
        updateBrand: builder.mutation({
            query: (data) => {
                const requestData = {
                    id: data.id,
                    brand: data.brand,
                    brandShort: data.brandShort,
                    brandItemVal: data.brandItemVal || null
                };

                return {
                    url: 'v1/systemdefinitions/updatebrand',
                    method: 'POST',
                    body: requestData
                };
            },
            invalidatesTags: ['Brand'],
            transformErrorResponse: (response, meta, arg) => {
                console.error('Update Brand Error:', response);
                return response;
            }
        })
    })
});

export const { useGetAllBrandsQuery, useUpdateBrandMutation } = brandApi;
